import { render, staticRenderFns } from "./component.vue?vue&type=template&id=1aac2991&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=1aac2991&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aac2991",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\progect\\guowai\\ex_express_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aac2991')) {
      api.createRecord('1aac2991', component.options)
    } else {
      api.reload('1aac2991', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=1aac2991&scoped=true&", function () {
      api.rerender('1aac2991', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-table-columns-fixed-controller/component.vue"
export default component.exports